// 레이드 4인 넷 판의 다른 사람 영웅 렌더(docs/RAID-PRD.md 0장 2단계): 파티 판 동료 렌더(party.ts)와 같은 PeersVisual(카엘 GPU 스키닝 인스턴스 + 이름표)을
// view.raidNet.peers(RaidNetLink가 채운 보간 구간)로 그린다. 넷 판에서만 보이고, 영웅 모델 GLB는 처음 판이 열릴 때 한 번 읽는다.
// 보간은 performance.now 시계(RaidClient와 같은 시계). 프레임 경로에서 새 객체를 만들지 않는다.
import * as THREE from 'three/webgpu';
import type { GameView } from '../../shared/types';
import { PeersVisual } from './peers';

export class RaidPeersRender {
  readonly group = new THREE.Group();
  readonly peers = new PeersVisual();
  private loading = false;

  constructor(private readonly now: () => number = () => performance.now()) {
    this.group.name = 'raid-peers';
    this.group.visible = false;
    this.group.add(this.peers.group);
  }

  get drawn(): number { return this.peers.drawn; }

  update(view: GameView): void {
    const rv = view.raidNet;
    const on = !!rv && rv.active;
    this.group.visible = on;
    if (!on) return;
    if (!this.loading) { this.loading = true; void this.peers.load(); }
    this.peers.update(rv.peers, this.now());
  }

  dispose(): void { this.peers.dispose(); }
}
